module.exports = __webpack_public_path__ + "cebeab76f3e312c2f2a424c26aa73c46.svg";